import React, {Component} from 'react';

declare const Kakao: any;
const analyticsId = 'G-EK0Y8CQQZH';

declare const window: any;
declare const gtag: any;
declare const fbq: any;



export const shareWithKakaotalk = ( shareLink: string, shareTitleButton: string, shareName: string, shareDescription: string) : void  => {
    // SDK 초기화 여부를 판단합니다.
    // Kakao.cleanup();
        Kakao.Link.createCustomButton({
            container: '#kakao-link-btn',
            // objectType: 'feed',
            templateId:44118,
            templateArgs: {
                title: `타로로 보는 찐본캐 테스트`,
                Title: `${shareTitleButton} ${shareName}`,
                Description: `${shareDescription}` ,
                ShareLink: `${shareLink}`,
                Img: `http://dev.moditt.com/front/tarotmoon_test/resultImg/${shareLink}.png`
            }
        });
    gtag('event', 'Share_Kakaotalk' , {
        event_category: 'Share_Kakaotalk',
        event_label: 'Share_Kakaotalk',
        value: 'Share_Kakaotalk'
    });
    fbq('track', 'Share_Kakaotalk' , {
        value: 'Share_Kakaotalk'
    });
};


export const shareWithFacebook = (shareLink: string, shareTitleButton: string, shareName: string, shareDescription: string ): void => {
    const shareTitle = ``;
    const shareURL = `https://www.facebook.com/sharer.php?u=https://tarotmoon.co.kr/front/#/result/${shareLink}?utm_source=facebook&utm_medium=share&utm_campaign=teststart`;
    window.open(shareURL, '_blank', 'width=600,height=500,,resizable=yes,scrollbars=yes');
    gtag('event', 'Share_Facebook' , {
        event_category: 'Share_Facebook',
        event_label: 'Share_Facebook',
        value: 'Share_Facebook'
    });
    fbq('track', 'Share_Facebook' , {
        value: 'Share_Facebook'
    });
};


